// extracted by mini-css-extract-plugin
module.exports = {"rentalTitle":"kP","boxArtWrapper":"kQ","rentalArtwork":"kR","rentalName":"kS"};